import { render } from "./manage-time-overview-employees.vue?vue&type=template&id=3fb7e3b9"
import script from "./manage-time-overview-employees.vue?vue&type=script&lang=js"
export * from "./manage-time-overview-employees.vue?vue&type=script&lang=js"
script.render = render

export default script